import {
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux";
import { setBottomSheet } from "../../../redux/mainSlice";
import { Colors, Spacing } from "../../../styles";
import Entities from "./Entities";
import Profiles from "./Profiles";
import WatchedCard from "./WatchedCard";

const BottomSheet = () => {
  const dispatch = useDispatch();
  const bottomSheet = useSelector((state: RootState) => state.main.bottomSheet);

  if (!bottomSheet) return <></>;

  return (
    <TouchableWithoutFeedback
      onPress={() => dispatch(setBottomSheet(undefined))}
    >
      <View style={styles.container}>
        <View style={styles.inner}>
          <KeyboardAvoidingView
            behavior={Platform.OS === "ios" ? "padding" : "height"}
          >
            <TouchableWithoutFeedback>
              <View style={styles.sheet}>
                <View style={styles.handle} />
                <View style={styles.content}>
                  {bottomSheet === "entities" && <Entities />}
                  {bottomSheet === "watchedCard" && <WatchedCard />}
                  {bottomSheet === "profiles" && <Profiles />}
                </View>
              </View>
            </TouchableWithoutFeedback>
          </KeyboardAvoidingView>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.8)",
    position: "absolute",
    bottom: 0,
  },
  inner: {
    width: "100%",
    height: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
  },
  sheet: {
    backgroundColor: Colors.plum900,
    // position: "absolute",
    // bottom: 0,
    width: "100%",
    padding: Spacing.page,
    paddingBottom: Spacing.page * 1.5,
    display: "flex",
    borderTopLeftRadius: Spacing.cardRadius,
    borderTopRightRadius: Spacing.cardRadius,
  },
  handle: {
    width: "25%",
    height: 3,
    borderRadius: 3 / 2,
    backgroundColor: "white",
    alignSelf: "center",
    marginBottom: Spacing.page,
  },
  content: {
    width: "100%",
  },
});

export default BottomSheet;
